import * as R from 'ramda';
import CONSTANTS from '../constants'

const initialState = {
  usageDataV2: {
    data: [],
    pagination: {
      totalItems: 0,
      page: 0,
      limit: 10,
    },
  },
  tourplanSync: {
    status: 'idle',
    checking: false,
    error: null,
  },
  userNames: [CONSTANTS.DEFAULT_USER_NAME_VALUE_IA_REPORT_FILTER],
  agentNames: [CONSTANTS.DEFAULT_AGENT_NAME_VALUE_IA_REPORT_FILTER],
  list: [],
  currentId: '',
  fileDialog: {
    open: false,
  },
};

const getUnique = (items, isUser) => {
  var lookup = {};
  var uniqueValues = isUser ? [CONSTANTS.DEFAULT_USER_NAME_VALUE_IA_REPORT_FILTER]: 
            [CONSTANTS.DEFAULT_AGENT_NAME_VALUE_IA_REPORT_FILTER];

  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var name = isUser ? item.creatorUserName : item.agentName;

    if (name && !(name in lookup)) {
      lookup[name] = 1;
      uniqueValues.push(name);
    }
  }

  return uniqueValues
}

export default function configuration(state = initialState, { type, payload, args }) {
  switch(type) {
    case 'genAi_getItineraries_SUCCESS': {
      return {
        ...state,
        list: payload,
      }
    }
    case 'genAI_setCurrentItineraryId':
      return {
        ...state,
        currentId: payload.id,
      };
    case 'genAi_getItinerary_SUCCESS': {
      if (!(payload && payload.id)) return state;
      return {
        ...state,
        [payload.id]: payload,
      };
    }
    case 'genAI_openFileDialog': {
      return {
        ...state,
        fileDialog: {
          open: true,
          itineraryId: state.currentId,
          files: R.pathOr([], [state.currentId, 'files'], state),
        },
      };
    }
    case 'genAi_closeFileDialog':
    case 'genAi_saveItinerary_SUCCESS':
      return {
        ...state,
        fileDialog: initialState.fileDialog,
      };
    case 'genAI_updatePropsForFileDialog': {
      return {
        ...state,
        fileDialog: {
          ...state.fileDialog,
          ...payload,
        },
      };
    }
    case 'genAi_getIAUsageReportV2': {
      return {
        ...state,
        loading: true
      };
    }
    case 'genAi_getIAUsageReportV2_SUCCESS': {
      return {
        ...state,
        usageDataV2: payload,
        userNames: getUnique(payload.data, true),
        agentNames: getUnique(payload.data, false),
        loading: false
      };
    }
    case 'genAi_getIAUsageReportV2_ERROR': {
      return {
        ...state,
        loading: false
      };
    }
    case 'genAi_startIATourplanSync_STARTED': {
      return {
        ...state,
        tourplanSync: {
          ...state.tourplanSync,
          status: 'starting',
          error: null,
        },
      };
    }
    case 'genAi_startIATourplanSync_SUCCESS':
    case 'genAi_getIATourplanSyncStatus_SUCCESS': {
      return {
        ...state,
        tourplanSync: {
          ...state.tourplanSync,
          ...payload,
          checking: false,
          error: payload.error || null,
        },
      };
    }
    case 'genAi_getIATourplanSyncStatus_STARTED': {
      return {
        ...state,
        tourplanSync: {
          ...state.tourplanSync,
          checking: true,
        },
      };
    }
    case 'genAi_startIATourplanSync_ERROR': {
      const response = R.pathOr({}, ['json'], payload);
      return {
        ...state,
        tourplanSync: {
          ...state.tourplanSync,
          ...response,
          status: response.status || 'failed',
          checking: false,
          error: response.error || 'Unable to start the Tourplan refresh.',
        },
      };
    }
    case 'genAi_getIATourplanSyncStatus_ERROR': {
      return {
        ...state,
        tourplanSync: {
          ...state.tourplanSync,
          status: 'failed',
          checking: false,
          error: R.pathOr('Unable to load the Tourplan refresh status.', ['json', 'error'], payload),
        },
      };
    }
    default:
      return state;
  }
}
